module.exports = __webpack_public_path__ + "img/sskanb-img.6f28c930.png";